function getItemsToShow() {
    const width = $(window).width();
    if (width <= 576) return 2;
    if (width <= 767) return 2;
    if (width <= 1117) return 3;
    return 4;
}
$(document).ready(function () {
    const $carousel = $('.cardwrapper.productList.equal-card');
    const $leftArrow = $('.left-arrow');
    const $rightArrow = $('.right-arrow');
    const $dotsContainer = $('.slider-dots-container');

    let itemsToShow = getItemsToShow();
    let totalItems;
    function initializeCarousel() {
        $carousel.slick({
            slidesToShow: itemsToShow,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            variableWidth: false,
            swipe: true,
            touchMove: true,
            centerMode: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1117,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

        setTimeout(() => {
            $carousel.slick('setPosition');
        }, 100);

        totalItems = $carousel.slick("getSlick").slideCount;
        updateDots(0);
        bindArrowEvents();
        bindDotEvents();
        bindAfterChange();
        $carousel.slick('slickGoTo', 0, true);
    }
    function updateDots(currentSlide) {
        const itemsToShow = getItemsToShow();
        const totalItems = $carousel.slick("getSlick").slideCount;
        const width = $(window).width();

        $dotsContainer.empty();

        if (width <= 576) {
            const groupSize = 2;
            const totalGroups = Math.ceil(totalItems / groupSize);
            const activeGroup = Math.floor(currentSlide / groupSize);

            for (let i = 0; i < totalGroups; i++) {
                const isActive = (i === activeGroup) ? 'active' : '';
                $dotsContainer.append(`<span class="dot ${isActive}" data-index="${i * groupSize}"></span>`);
            }
        } else {
            for (let i = 0; i < totalItems; i++) {
                const isActive = (i >= currentSlide && i < currentSlide + itemsToShow) ? 'active' : '';
                $dotsContainer.append(`<span class="dot ${isActive}" data-index="${i}"></span>`);
            }
        }
        bindDotEvents();
    }
    function bindDotEvents() {
        $dotsContainer.off('click', '.dot').on('click', '.dot', function () {
            const targetIndex = parseInt($(this).attr('data-index'));
            $carousel.slick('slickGoTo', targetIndex);
        });
    }
    function bindArrowEvents() {
        $leftArrow.off('click').on('click', function () {
            $carousel.slick('slickPrev');
        });

        $rightArrow.off('click').on('click', function () {
            $carousel.slick('slickNext');
        });
    }
    function bindAfterChange() {
        $carousel.off('afterChange').on('afterChange', function (event, slick, currentSlide) {
            updateDots(currentSlide);

            const maxIndex = slick.slideCount - slick.options.slidesToShow;
            const width = $(window).width();
            let activeColor = '#8E9093';
            let inactiveColor = '#E6E7E8';

            if (width <= 576) {
                activeColor = '#939598';
                inactiveColor = '#E6E7E8';
            } else if (width <= 1117) {
                activeColor = '#939598';
                inactiveColor = '#E6E7E8';
            }

            $leftArrow.css('pointer-events', currentSlide <= 0 ? 'none' : 'auto');
            $leftArrow.find('path').attr('fill', currentSlide <= 0 ? inactiveColor : activeColor);

            $rightArrow.css('pointer-events', currentSlide >= maxIndex ? 'none' : 'auto');
            $rightArrow.find('path').attr('fill', currentSlide >= maxIndex ? inactiveColor : activeColor);
        });
    }

    initializeCarousel();

    // Keyboard navigation
    $(document).on('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
            $carousel.slick('slickPrev');
        } else if (e.key === 'ArrowRight') {
            $carousel.slick('slickNext');
        }
    });

    $(window).on('resize', function () {
        itemsToShow = getItemsToShow();
        $carousel.slick('slickSetOption', 'slidesToShow', itemsToShow, true);
        $carousel.slick('slickSetOption', 'slidesToScroll', 1, true);

        totalItems = $carousel.slick("getSlick").slideCount;
        updateDots(0);
        $carousel.slick('slickGoTo', 0, true);
    });
});